<template>
  <div v-if="visible" class="toast">
    <img class="icon" v-show="show_error != 'no_show_error'" src="./error_icon.png" alt="" />
    {{ message }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      message: '',
      show_error: '',
    }
  },
  methods: {
    showToast(msg, duration = 2000, show_error) {
      this.message = msg
      this.visible = true
      this.show_error = show_error
      setTimeout(() => {
        this.visible = false
      }, duration)
    },
  },
}
</script>

<style scoped lang="less">
@import '../../assets/css/zIndex.less';
.toast {
  position: fixed;
  top: 42px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  color: #202226;
  font-size: 18px;
  padding: 14px 20px;
  z-index: @toast + 1;
  box-shadow: 0px 10px 25px 4px rgba(0, 0, 0, 0.18);
  border-radius: 10px;
  animation: slide 300ms ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  @keyframes slide {
    0% {
      opacity: 0;
      transform: translate(-50%, -50px);
    }
    100% {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }
  .icon {
    width: 28px;
    height: 28px;
    margin-right: 12px;
  }
}
@media (max-width: 1024px) {
  .toast {
    top: 1rem;
    font-size: 0.24rem;
    padding: 0.16rem 0.22rem;
    box-shadow: 0px 0.1rem 0.25rem 0.04rem rgba(0, 0, 0, 0.18);
    border-radius: 0.1rem;
    .icon {
      width: 0.3rem;
      height: 0.3rem;
      margin-right: 0.12rem;
    }
  }
}
</style>
